/** Shared journey filter options and funnel modes. */

export const FUNNEL_MODES = [
  { id: 'attendance', label: 'Attendance', hint: 'Event-timed · pending held out' },
  { id: 'membership', label: 'Membership & add-ons', hint: 'CMP product lines' },
  { id: 'sales_channel', label: 'Sales channel', hint: 'Online vs on-site' },
];

export const JOURNEY_FILTER_OPTIONS = {
  seasons: [
    { value: '2025-26', label: 'Season 2025/26 · Aug 1 – today' },
    { value: '2024-25', label: 'Season 2024/25' },
  ],
  venues: [
    { value: 'all', label: 'Venue: all' },
    { value: 'jutlander', label: 'Venue: Jutlander Bank Arena' },
  ],
  events: [
    { value: 'all', label: 'Event: all home fixtures' },
    { value: 'gog', label: 'Event: AaB Håndbold – GOG' },
    { value: 'skjern', label: 'Event: AaB Håndbold – Skjern' },
  ],
  channels: [
    { value: 'all', label: 'Channel: all' },
    { value: 'online', label: 'Channel: online' },
    { value: 'onsite', label: 'Channel: on-site / POS' },
  ],
  minShares: [
    { value: '0.01', label: 'Min. share: 1%' },
    { value: '0.05', label: 'Min. share: 5%' },
    { value: '0.10', label: 'Min. share: 10%' },
  ],
};
